module.exports = __webpack_public_path__ + "static/futur-call-2-d044ed70f97235f130f2d4c26cf18f0d.jpg";